/**
 * Safari's Audio Session API (iOS 16.4+). After the microphone was used, iOS keeps the page in
 * "play and record": speech then goes to the quiet earpiece or is muted by the silent switch.
 * Reading aloud asks for "playback" (loudspeaker, plays in silent mode like a media app) and
 * hands control back with "auto" afterwards, so the next recording works as before.
 */
type AudioSessionType = 'auto' | 'playback' | 'play-and-record' | 'transient' | 'ambient';

export function setAudioSession(
  type: AudioSessionType,
  nav: Navigator | undefined = globalThis.navigator,
): void {
  const session = (nav as (Navigator & { audioSession?: { type: string } }) | undefined)
    ?.audioSession;
  if (!session) return;
  try {
    session.type = type;
  } catch {
    // Not settable in this browser or state; playback still works as before.
  }
}
